/* eslint-disable @typescript-eslint/naming-convention */

import SHIPPING_METHODS from '../../../constants/ShippingMethods';
import { IDeliveryOption2 as IDeliveryOption } from '../../../domain/entities/Transaction/Transaction';
import { IShippingMethod } from '../../../domain/entities/ShippingMethodsCollection/ShippingMethodsCollection';
import { IShipOption, IDeliveryOptionResponse } from '../../IApiResponses';
import { DeliveryOptions } from '../../../constants/Constants';

const shipOptionsMapper = {
  response(shipOptions: IShipOption[]): IShippingMethod[] {
    return shipOptions.map(item => ({
      availableWindow: item.available_window ? {
        startHour: item.available_window.start_hour,
        stopHour: item.available_window.stop_hour,
        timeZone: item.available_window.timezone,
      } : null,
      discount: item.discount,
      estimatedDeliveryEndDate: item.estimated_delivery_end_date,
      estimatedDeliveryStartDate: item.estimated_delivery_start_date,
      id: (item.ship_method_id || item.id) as SHIPPING_METHODS,
      leadTimeValue: item.leadtimevalue || item.lead_time_value,
      name: item.name,
      nextAvailableSat: item.next_available_sat,
      price: item.price,
      skuId: item.sku_base_id,
      sortOrder: item.sort_order,
      totalPrice: item.discount ? item.price + item.discount : item.price,
    }));
  },
};

const deliveryOptionsMapper2 = {
  response(deliveryOptions: IDeliveryOptionResponse[]): IDeliveryOption[] {
    return deliveryOptions?.map(deliveryOption => {
      const { default_shipping_method_id, shipping_methods, name, config } = deliveryOption;
      const shipMethods = shipOptionsMapper.response(shipping_methods);
      return {
        config,
        defaultMethodId: default_shipping_method_id,
        name: name as DeliveryOptions,
        shipMethods,
      };
    });
  },
};

export default deliveryOptionsMapper2;
